export const PRODUCTS_B = {
  'project-finance': {
    name: 'Project Finance',
    heroTitle: 'Project Finance for Ideas That Deserve Scale',
    heroSub: 'Greenfield and brownfield projects from ₹5 Crore to ₹500 Crore — hotels, hospitals, manufacturing plants, schools and renewable energy — structured, syndicated and executed end to end.',
    amount: '₹5 Cr – ₹500 Cr',
    timeline: '6–12 weeks',
    rate: '9.5% p.a. onwards',
    metaTitle: 'Project Finance & Funding in India | LOANYARD CAPITAL',
    metaDescription: 'Project finance from ₹5 Cr to ₹500 Cr — manufacturing, hospitals, hotels, solar, schools. DPR preparation, syndication, multiple financing partners. Expert advisory.',
    focusKeyword: 'project finance India',
    intro: [
      'Project finance is where advisory earns its keep. A greenfield hospital, a manufacturing plant or a hotel is judged not on past profits but on projected cash flows — which means the quality of the Detailed Project Report, the realism of assumptions and the credibility of the promoter narrative decide whether capital flows or the file gathers dust.',
      'LOANYARD CAPITAL has structured project debt across manufacturing, healthcare, hospitality, education and renewable energy. Our in-house team builds the complete DPR — market assessment, technical configuration, cost of project, means of finance, sensitivity analysis — to the standards appraisal teams at banks and financial institutions expect.',
      'Beyond documentation, we design the capital stack: promoter equity, bank term debt, subsidy layering (state industrial policies, PLI where applicable), and mezzanine where equity is tight. For larger mandates we syndicate across multiple lenders, run competitive term-sheet processes and negotiate covenants that leave the promoter room to operate.'
    ],
    benefits: [
      'Complete DPR and financial-model preparation in-house',
      'Debt from ₹5 Cr to ₹500 Cr, single-lender or syndicated',
      'Capital-stack design: equity, debt, subsidy and mezzanine',
      'Moratorium and step-up repayment matched to gestation',
      'Subsidy and incentive layering (state policies, PLI)',
      'End-to-end execution through financial closure'
    ],
    whoShouldApply: [
      'Promoters setting up greenfield manufacturing units',
      'Hospital, school and hotel developers',
      'Existing companies undertaking major brownfield expansion',
      'Renewable energy (solar/wind) project developers',
      'Infrastructure and warehousing developers'
    ],
    eligibility: [
      'Promoter contribution typically 25–35% of project cost',
      'Relevant promoter experience or strong tie-ups',
      'Land in possession / advanced acquisition stage',
      'Viable DSCR (typically 1.25x+) in projections',
      'Statutory approvals achievable within timeline'
    ],
    documents: [
      'Land documents and approvals status',
      'Promoter KYC, net worth and experience profile',
      'Quotations for plant, machinery and civil works',
      'Existing entity financials (for brownfield)',
      'Market/off-take evidence where available',
      'We prepare: DPR, CMA, financial model'
    ],
    industries: ['Manufacturing', 'Hospitals & Healthcare', 'Hotels & Resorts', 'Education', 'Solar & Renewables', 'Cold Chain & Warehousing', 'Food Parks', 'Textiles'],
    process: [
      ['Feasibility', 'We stress-test the project economics before anything else.'],
      ['DPR & Model', 'Bank-grade DPR, projections and sensitivity analysis.'],
      ['Capital Stack', 'Equity, debt, subsidy and mezzanine layers designed.'],
      ['Syndication', 'Competitive placement and term-sheet negotiation.'],
      ['Financial Closure', 'Documentation, conditions precedent and disbursement.']
    ],
    faqs: [
      ['What promoter contribution is required?', 'Typically 25–35% of project cost, part of which can be land value already held; subsidy layers can reduce cash equity.'],
      ['How long does project finance take?', 'Six to twelve weeks from complete DPR to sanction for mid-size projects; large syndications can take longer.'],
      ['Do you prepare the DPR?', 'Yes — DPR, financial model and CMA are prepared in-house to appraisal standards.'],
      ['Can first-time promoters get project debt?', 'Yes, with strong sector hires or technical tie-ups; structure and equity cushion compensate for limited track record.'],
      ['What moratorium is available?', 'Construction period plus 6–12 months is standard; repayments can step up as the ramp-up matures.'],
      ['Do you arrange subsidies too?', 'We layer state capital/interest subsidies and central schemes into the means of finance where the project qualifies.'],
      ['What DSCR do lenders want?', 'Average DSCR of 1.25–1.5x with sensible sensitivities is the usual comfort zone.'],
      ['Can working capital be tied into the project loan?', 'Yes — we structure integrated limits so the unit is not starved post-commissioning.'],
      ['What security is required?', 'Project assets as primary security; collateral expectations vary and are negotiable with structure.'],
      ['Do you syndicate across multiple banks?', 'Yes — for larger mandates we run multi-lender processes to optimise pricing and terms.']
    ],
    related: ['debt-syndication', 'machinery-loan', 'working-capital-finance', 'loan-against-property']
  },

  'debt-syndication': {
    name: 'Debt Syndication',
    heroTitle: 'Institutional Debt, Syndicated on Your Terms',
    heroSub: 'For mid-market and large corporates raising ₹25 Crore to ₹1,000 Crore — we run competitive, multi-lender processes across banks, NBFCs, AIFs and debt funds to deliver the right capital at the right price.',
    amount: '₹25 Cr – ₹1,000 Cr',
    timeline: '6–16 weeks',
    rate: 'Structure-linked',
    metaTitle: 'Debt Syndication Services India | LOANYARD CAPITAL',
    metaDescription: 'Corporate debt syndication ₹25 Cr–₹1,000 Cr. Term debt, structured finance, NCDs, refinancing. Multi-lender competitive processes. Institutional advisory.',
    focusKeyword: 'debt syndication India',
    intro: [
      'Above a certain scale, borrowing stops being a product decision and becomes a capital-markets exercise. The questions multiply: bank debt or NCDs? Amortising or bullet? Domestic or foreign currency? One lender\'s covenant package can quietly cost more than another\'s extra 50 basis points. This is the terrain of debt syndication.',
      'LOANYARD CAPITAL acts as sell-side advisor to the borrower. We prepare the information memorandum, build the financial model, define the target structure and then run a disciplined process across the credit universe — commercial banks, NBFCs, AIFs, credit funds and family offices — creating genuine competition for your paper.',
      'Mandates include growth capex, acquisition funding, refinancing of expensive or maturing debt, promoter funding against securities, and special-situation capital. Our value is measured in basis points saved, covenants loosened and certainty of close — and we stay engaged through documentation until money is in the bank.'
    ],
    benefits: [
      'Competitive multi-lender processes, not single-bank dependence',
      'Access to banks, NBFCs, AIFs, credit funds and NCD investors',
      'Structures: term debt, unitranche, mezzanine, LRD, NCDs',
      'Refinancing that releases cash flow and collateral',
      'Institutional-grade IM and model preparation',
      'Negotiation of pricing, covenants and security jointly'
    ],
    whoShouldApply: [
      'Mid-market companies raising ₹25 Cr+ growth debt',
      'Corporates refinancing maturing or expensive facilities',
      'Promoters funding acquisitions or buyouts',
      'Real estate and infra developers at project scale',
      'Companies seeking covenant-light structured capital'
    ],
    eligibility: [
      'Meaningful EBITDA or hard-asset base',
      'Audited financials and reasonable leverage headroom',
      'Clear use of proceeds and repayment thesis',
      'Promoter alignment on structure and security',
      'Scale: usually ₹25 Cr+ requirement'
    ],
    documents: [
      'Audited financials (3 years) and provisionals',
      'Existing debt schedule with terms',
      'Business plan / projections',
      'Security and collateral summary',
      'Group structure and promoter profile',
      'We prepare: IM, model, lender Q&A pack'
    ],
    industries: ['Manufacturing', 'Pharma', 'Infrastructure', 'Real Estate', 'Renewables', 'Healthcare', 'Consumer & Retail', 'Logistics'],
    process: [
      ['Mandate & Strategy', 'Target structure, quantum and lender universe agreed.'],
      ['IM & Model', 'Institutional documentation prepared in-house.'],
      ['Market Sounding', 'Soft-sounding with selected credit desks.'],
      ['Competitive Bids', 'Term sheets solicited, compared and negotiated.'],
      ['Documentation & Close', 'Facility documents to disbursement, fully managed.']
    ],
    faqs: [
      ['What size mandates do you syndicate?', 'Typically ₹25 Crore to ₹1,000 Crore, across single-lender and club/consortium formats.'],
      ['Which investors do you reach beyond banks?', 'NBFCs, AIFs, private credit funds, insurance treasuries and NCD investors, matched to structure and risk.'],
      ['How do you charge?', 'Success-linked fees on funded amounts; any retainer is adjusted against success fees. Terms are agreed upfront in the mandate.'],
      ['Can you refinance our existing high-cost debt?', 'Yes — refinancing and consolidation to reduce cost or extend tenor is among our most frequent mandates.'],
      ['What is unitranche debt?', 'A single blended facility replacing senior+mezzanine layers — faster and simpler, often from credit funds.'],
      ['Do you arrange acquisition funding?', 'Yes — LBO-style structures, promoter funding and target-cash-flow-backed debt for control transactions.'],
      ['How long does syndication take?', 'Six to ten weeks for straightforward bank deals; twelve to sixteen for structured or multi-tranche capital.'],
      ['Will you negotiate covenants, not just price?', 'Always. Headroom, cure rights and security carve-outs are negotiated as hard as pricing.'],
      ['Can loss-making companies raise structured debt?', 'Asset-backed and special-situation capital exists for credible turnarounds; pricing reflects risk.'],
      ['Do you stay involved after the term sheet?', 'Yes — through documentation, CP satisfaction and disbursement. Execution is where deals are won or lost.']
    ],
    related: ['project-finance', 'working-capital-finance', 'loan-against-property', 'trade-finance-solutions']
  },

  'trade-finance-solutions': {
    name: 'Trade Finance Solutions',
    heroTitle: 'Trade Finance That Keeps Global Commerce Moving',
    heroSub: 'Letters of credit, bank guarantees, export-import funding, buyer\'s credit and supply-chain finance — a complete trade finance suite for importers, exporters and domestic traders.',
    amount: '₹1 Cr – ₹200 Cr',
    timeline: '1–4 weeks',
    rate: 'Instrument-linked',
    metaTitle: 'Trade Finance Solutions — LC, BG, Export-Import | LOANYARD CAPITAL',
    metaDescription: 'Complete trade finance: LC, bank guarantee, export & import funding, buyer\'s credit, supply chain finance. ₹1 Cr–₹200 Cr limits. Expert structuring.',
    focusKeyword: 'trade finance India',
    intro: [
      'Trade runs on trust — and trade finance is how banks manufacture that trust between counterparties who may never meet. The right instrument at the right moment lets an importer command credit terms, an exporter ship with confidence, and a contractor bid for projects many times its balance sheet.',
      'LOANYARD CAPITAL structures the complete trade finance toolkit: sight and usance letters of credit, inland and foreign bank guarantees, pre- and post-shipment export finance, buyer\'s and supplier\'s credit for imports, and supply-chain finance programmes that fund entire vendor ecosystems.',
      'Because non-fund-based limits consume less capital than loans, banks price them attractively — but sanctioning them requires precise presentation of trade cycles and counterparty quality. We build that case, negotiate margins (cash margins are frequently reducible from 100% to 10–25%), and place limits with banks whose trade desks match your corridors.'
    ],
    benefits: [
      'LC and BG limits with cash margins as low as 10%',
      'Pre/post-shipment export finance in INR and FCY',
      'Buyer\'s credit and supplier\'s credit for imports',
      'LC discounting for immediate liquidity on receivables',
      'Supply-chain finance for dealers and vendors',
      'Corridor-matched bank placement (USD, EUR, CNY, AED)'
    ],
    whoShouldApply: [
      'Importers of raw materials, machinery and merchandise',
      'Exporters extending credit to overseas buyers',
      'EPC contractors requiring performance and advance BGs',
      'Domestic traders selling to corporates on usance terms',
      'Anchor corporates funding their vendor networks'
    ],
    eligibility: [
      'Import-Export Code for cross-border trade',
      '2+ years of trading track record preferred',
      'Financials supporting the assessed limits',
      'Genuine underlying trade transactions',
      'Satisfactory bureau and banking conduct'
    ],
    documents: [
      'IEC, GST and business KYC',
      'Last 2 years financials',
      '12-month bank statements',
      'Sample trade documents (POs, invoices, BLs)',
      'Counterparty details for limits assessment',
      'Existing trade limit sanctions, if any'
    ],
    industries: ['Exporters', 'Importers', 'EPC & Infrastructure', 'Metals & Commodities', 'Chemicals', 'Agro & Food', 'Electronics', 'Pharma'],
    process: [
      ['Trade-Cycle Mapping', 'We chart your flows, tenors and counterparties.'],
      ['Instrument Design', 'The optimal mix of LC, BG, funding and discounting.'],
      ['Limit Placement', 'Placement with banks strong in your trade corridors.'],
      ['Margin Negotiation', 'Cash margins and commissions negotiated down.'],
      ['Ongoing Operations', 'Issuance support and limit utilisation advisory.']
    ],
    faqs: [
      ['What cash margin is needed for an LC?', 'With sound financials, 10–25% is achievable against the 100% many businesses unnecessarily place.'],
      ['What is the difference between LC and BG?', 'An LC is a payment mechanism for trade; a BG is a default-triggered assurance of performance or payment.'],
      ['Can you arrange buyer\'s credit for imports?', 'Yes — offshore funding against import LCs, typically cheaper than rupee borrowing after hedging.'],
      ['Do you fund exports before shipment?', 'Yes — packing credit in INR or foreign currency funds procurement and production against orders or LCs.'],
      ['What is LC discounting?', 'Converting a usance LC receivable into immediate cash at bank-risk pricing — often the cheapest liquidity a supplier can access.'],
      ['Can new importers get LC limits?', 'With strong financials or margin support, yes; limits scale as track record builds.'],
      ['Do you handle SBLCs?', 'Yes — standby LCs for overseas obligations, subject to bank policy and underlying purpose.'],
      ['What BG types do you arrange?', 'Bid bond, performance, advance payment, retention and financial guarantees, inland and foreign.'],
      ['Is supply-chain finance different from bill discounting?', 'SCF is anchor-led and programmatic across many vendors; bill discounting is transaction-level. We structure both.'],
      ['Which currencies do you cover?', 'USD, EUR, GBP, AED, CNY and other major corridors through our banking network.']
    ],
    related: ['lc-discounting', 'bank-guarantee', 'bill-discounting', 'working-capital-finance']
  },

  'bill-discounting': {
    name: 'Bill Discounting',
    heroTitle: 'Turn Invoices into Immediate Working Capital',
    heroSub: 'Stop waiting 60–120 days for payments. Discount your trade receivables and unlock cash the day you raise the invoice — with or without recourse.',
    amount: '₹50 Lakh – ₹100 Cr',
    timeline: '5–15 days setup',
    rate: '0.75% – 1.5% per month',
    metaTitle: 'Bill & Invoice Discounting Services | LOANYARD CAPITAL',
    metaDescription: 'Bill discounting & invoice finance — convert receivables to instant cash. Limits ₹50 Lakh–₹100 Cr, recourse & non-recourse, TReDS advisory. Free setup.',
    focusKeyword: 'bill discounting',
    intro: [
      'Every invoice you raise on credit is an interest-free loan to your customer. For businesses supplying corporates on 60, 90 or 120-day terms, receivables quietly become the largest use of capital on the balance sheet — capital that could be funding the next order instead.',
      'Bill discounting reverses the equation. A bank or financier pays you most of the invoice value upfront (typically 80–90%) and collects from your buyer at maturity. Strong buyers make even modest suppliers financeable, because the credit decision rests on the payer, not the seller.',
      'LOANYARD CAPITAL sets up discounting programmes across the spectrum: bank bill limits, NBFC invoice finance, factoring with collection services, non-recourse structures that transfer buyer default risk, and TReDS onboarding for MSMEs supplying large corporates. We match the structure to your buyer profile and negotiate discount rates that respect your margins.'
    ],
    benefits: [
      'Cash within 24–48 hours of invoice acceptance',
      '80–90% advance against invoice value',
      'Credit decision based on your buyer\'s strength',
      'Non-recourse options remove buyer default risk',
      'Off-balance-sheet treatment possible via factoring',
      'TReDS access for MSME suppliers to corporates'
    ],
    whoShouldApply: [
      'Suppliers to corporates and PSUs on credit terms',
      'Manufacturers with 60–120 day receivable cycles',
      'Service providers billing enterprise clients',
      'Distributors managing seasonal cash-flow humps',
      'MSMEs eligible for TReDS platforms'
    ],
    eligibility: [
      'Invoices on creditworthy corporate/PSU buyers',
      'Undisputed, accepted receivables',
      'Business vintage of 1–2 years',
      'GST-registered transactions',
      'Buyer concentration within programme norms'
    ],
    documents: [
      'Business KYC and GST registration',
      'Buyer list with dealing history',
      'Sample invoices and POs',
      '12-month bank statements',
      'Last 2 years financials',
      'Receivables ageing summary'
    ],
    industries: ['Auto Components', 'FMCG Suppliers', 'Pharma', 'Engineering', 'IT Services', 'Logistics Vendors', 'Packaging', 'Textiles'],
    process: [
      ['Buyer Assessment', 'Your receivable book is mapped by buyer quality.'],
      ['Programme Design', 'Bank, NBFC, factoring or TReDS — optimally selected.'],
      ['Limit Setup', 'Limits sanctioned per buyer or across the pool.'],
      ['First Discounting', 'Invoices submitted, cash credited within 24–48 hours.'],
      ['Rolling Utilisation', 'Continuous discounting as invoices are raised.']
    ],
    faqs: [
      ['How much of my invoice do I receive upfront?', 'Typically 80–90%, with the balance (minus charges) settled when your buyer pays.'],
      ['What does bill discounting cost?', 'Roughly 0.75–1.5% per month on utilised amounts, depending on buyer quality and structure — often cheaper than CC for receivable-heavy firms.'],
      ['What is non-recourse discounting?', 'The financier absorbs buyer default risk. It costs slightly more but converts your receivable into risk-free cash.'],
      ['What is TReDS?', 'RBI-regulated platforms (M1xchange, RXIL, Invoicemart) where MSME invoices to corporates are auctioned to financiers — often at the finest rates. We manage onboarding.'],
      ['Will my buyer know about the arrangement?', 'In disclosed programmes and TReDS, yes; undisclosed invoice-finance options also exist where relationships are sensitive.'],
      ['Is collateral needed?', 'Generally no hard collateral — the receivable itself secures funding.'],
      ['Can service invoices be discounted?', 'Yes, accepted service invoices on strong counterparties qualify under invoice-finance programmes.'],
      ['How fast is programme setup?', '5–15 days to first funding, depending on buyer verification.'],
      ['What if my buyer pays late?', 'Grace periods apply; interest simply runs for the actual period. Chronic delays are re-priced or excluded.'],
      ['Factoring vs discounting — the difference?', 'Factoring adds collection services and ledger management and can be non-recourse; discounting is pure financing. We advise the fit.']
    ],
    related: ['working-capital-finance', 'trade-finance-solutions', 'lc-discounting', 'msme-business-funding']
  },

  'lc-discounting': {
    name: 'LC Discounting',
    heroTitle: 'Immediate Liquidity Against Letters of Credit',
    heroSub: 'Holding a usance LC? Convert it into cash today at bank-risk pricing — the cheapest receivable finance available to Indian suppliers and exporters.',
    amount: '₹1 Cr – ₹200 Cr',
    timeline: '3–7 days',
    rate: '7.5% p.a. onwards',
    metaTitle: 'LC Discounting & Bill Discounting under LC | LOANYARD CAPITAL',
    metaDescription: 'LC discounting at 7.5% onwards — inland & export usance LCs converted to instant cash at bank-risk pricing. ₹1 Cr–₹200 Cr. Fast 3–7 day execution.',
    focusKeyword: 'LC discounting',
    intro: [
      'A usance letter of credit is a bank\'s irrevocable promise to pay you on a future date. That promise is a high-grade financial asset — and like any high-grade asset, it can be monetised. LC discounting converts your 90 or 180-day LC receivable into immediate funds at rates linked to the LC-issuing bank\'s credit, not yours.',
      'This is the crucial insight: because the discounting bank\'s risk is on the issuing bank, suppliers with modest balance sheets access near-prime pricing — frequently 7.5–9.5% annualised for LCs of strong Indian banks, and competitive LIBOR/SOFR-linked pricing for export LCs from acceptable foreign banks.',
      'LOANYARD CAPITAL arranges discounting of inland and export LCs, negotiates confirmation where issuing banks need enhancement, and structures standing arrangements for suppliers who receive LCs routinely — so every future LC turns into cash within days of shipment.'
    ],
    benefits: [
      'Pricing on the issuing bank\'s credit, not yours',
      'Rates from 7.5% p.a. for strong-bank LCs',
      'Inland and export (foreign bank) LCs covered',
      'Without-recourse structures available',
      'Standing limits for recurring LC flows',
      'Confirmation arranged for weaker issuing banks'
    ],
    whoShouldApply: [
      'Suppliers receiving usance LCs from corporate buyers',
      'Exporters holding LCs from overseas banks',
      'Commodity and metals traders on LC terms',
      'Sub-vendors in EPC chains paid via LC',
      'Businesses negotiating LC terms into new contracts'
    ],
    eligibility: [
      'Genuine usance LC from an acceptable bank',
      'Clean, compliant shipping/trade documents',
      'Underlying GST-compliant transaction',
      'Basic KYC of the beneficiary entity',
      'LC free of onerous or unusual clauses'
    ],
    documents: [
      'Copy of the LC and amendments',
      'Invoice, transport documents, packing list',
      'Certificate of acceptance where applicable',
      'Business KYC and banking details',
      'GST registration',
      'Past LC flow summary for standing limits'
    ],
    industries: ['Metals & Steel', 'Commodities', 'Textiles & Yarn', 'Chemicals', 'Engineering Goods', 'Agro Exports', 'Electronics', 'Paper & Packaging'],
    process: [
      ['LC Review', 'We vet the LC, issuing bank and document set.'],
      ['Bank Matching', 'Placement with the discounting desk offering finest pricing.'],
      ['Document Negotiation', 'Compliant presentation and acceptance secured.'],
      ['Discounting', 'Funds credited, typically within 3–7 days of acceptance.'],
      ['Standing Facility', 'Repeatable limits established for future LCs.']
    ],
    faqs: [
      ['Why is LC discounting cheaper than other finance?', 'Because the discounter\'s risk is the LC-issuing bank, not your business — bank risk commands the finest pricing in credit markets.'],
      ['What LC tenors can be discounted?', 'Commonly 30–180 days usance; longer tenors case by case.'],
      ['Is it with or without recourse?', 'Both exist. Without-recourse (on accepted documents) fully transfers payment risk to the discounting bank.'],
      ['Can foreign-bank LCs be discounted in India?', 'Yes, subject to the issuing bank being acceptable; confirmation by an Indian/global bank bridges weaker names.'],
      ['What if documents have discrepancies?', 'Discounting follows acceptance. We pre-check documents to avoid discrepancy delays and negotiate waivers where needed.'],
      ['How fast can I receive funds?', 'Three to seven days from acceptance, faster under standing arrangements.'],
      ['Does my buyer need to know?', 'The issuing bank\'s acceptance process involves the buyer\'s bank; commercially, discounting is standard practice and rarely sensitive.'],
      ['What amounts can be discounted?', 'From ₹1 Crore single LCs to ₹200 Crore+ programme flows.'],
      ['Can SBLC be discounted?', 'Standby LCs are guarantee instruments; monetisation differs and is assessed case by case.'],
      ['Do you help negotiate LC terms in my contracts?', 'Yes — we advise clause structures upfront so your future LCs are cleanly discountable.']
    ],
    related: ['trade-finance-solutions', 'bill-discounting', 'bank-guarantee', 'working-capital-finance']
  },

  'bank-guarantee': {
    name: 'Bank Guarantee',
    heroTitle: 'Bank Guarantees That Win You Bigger Contracts',
    heroSub: 'Bid bonds, performance, advance payment and financial guarantees — BG limits with minimal cash margin, so your capital works in the business, not in bank deposits.',
    amount: '₹50 Lakh – ₹200 Cr',
    timeline: '1–3 weeks',
    rate: '0.75% – 2% p.a. commission',
    metaTitle: 'Bank Guarantee (BG) Limits & Issuance | LOANYARD CAPITAL',
    metaDescription: 'Bank guarantee limits with 10–25% cash margin — bid, performance, advance & financial BGs up to ₹200 Cr. Fast issuance, fine commissions. Expert advisory.',
    focusKeyword: 'bank guarantee',
    intro: [
      'In contracting, infrastructure and government supply, the bank guarantee is the ticket to play. Tenders demand bid bonds; awards demand performance guarantees; mobilisation advances demand APGs. A contractor\'s growth is often capped not by capability but by BG limits — and by the cash margins banks demand against them.',
      'LOANYARD CAPITAL structures BG limits that scale with your order book. We present your execution track record, receivable quality and net worth so banks sanction meaningful limits at cash margins of 10–25% instead of the 50–100% that starves working capital. For urgent tender deadlines, we arrange fast-track issuance through banks whose trade desks move at deal speed.',
      'Our coverage spans inland and foreign BGs, e-BGs on the NeSL platform, and guarantee restructuring — replacing high-margin BGs with efficiently margined limits, releasing locked FDs back into your business.'
    ],
    benefits: [
      'Cash margins negotiated to 10–25%',
      'All BG types: bid, performance, advance, retention, financial',
      'Limits from ₹50 Lakh to ₹200 Crore',
      'Fast-track issuance for tender deadlines',
      'e-BG capability via NeSL',
      'Release of FDs locked against old high-margin BGs'
    ],
    whoShouldApply: [
      'EPC and infrastructure contractors',
      'Government and PSU suppliers/tenderers',
      'Equipment vendors giving performance warranties',
      'Real estate developers (RERA and authority BGs)',
      'Importers/exporters needing financial guarantees'
    ],
    eligibility: [
      'Track record of contract execution',
      'Financials supporting the assessed BG limit',
      'Order book / tender pipeline visibility',
      'Acceptable banking conduct',
      'Margin and collateral within nego range'
    ],
    documents: [
      'Business KYC and financials (2–3 years)',
      'Order book and completed-works summary',
      'Tender/contract documents needing BGs',
      '12-month bank statements',
      'Existing BG limits and margin details',
      'Net worth statements of promoters'
    ],
    industries: ['EPC & Infrastructure', 'Road & Highways', 'Power & Utilities', 'Water Projects', 'Defence Suppliers', 'Railways Vendors', 'Real Estate', 'IT & Services'],
    process: [
      ['Limit Assessment', 'BG requirement mapped against your order pipeline.'],
      ['Bank Placement', 'Placement with banks aggressive on your sector.'],
      ['Margin Negotiation', 'Cash margin and commission driven down.'],
      ['Issuance', 'Formats vetted; BGs issued to beneficiary timelines.'],
      ['Limit Management', 'Ongoing issuance, extensions and releases handled.']
    ],
    faqs: [
      ['What cash margin will I need?', 'Well-presented contractors obtain 10–25% margins; weaker files get pushed to 50–100% — precisely what we negotiate away.'],
      ['What does a BG cost?', 'Annual commission of roughly 0.75–2% depending on type, tenor and margin, plus stamped documentation.'],
      ['How fast can a BG be issued?', 'Under sanctioned limits, 24–72 hours; new limits take 1–3 weeks to establish.'],
      ['What is the difference between performance and financial BG?', 'Performance BGs assure contract execution; financial BGs assure monetary payment — banks price financial BGs higher.'],
      ['Can BG formats demanded by beneficiaries be negotiated?', 'Yes — we vet formats to remove onerous clauses banks resist, avoiding last-minute rejections.'],
      ['What happens if a BG is invoked?', 'The bank pays the beneficiary and recovers from you; invocation risk management and dispute handling are part of our advisory.'],
      ['Do you arrange foreign BGs?', 'Yes — foreign BGs and SBLCs for overseas beneficiaries through correspondent networks.'],
      ['Can my FDs locked as margin be released?', 'Frequently — by shifting BGs to limits with lower margin or collateral substitution.'],
      ['Is an e-BG acceptable to government bodies?', 'Increasingly yes; NeSL e-BGs are gaining acceptance across PSUs and departments.'],
      ['Can new contractors get BG limits?', 'Modest starter limits with higher margins are achievable and scale rapidly with execution history.']
    ],
    related: ['trade-finance-solutions', 'working-capital-finance', 'lc-discounting', 'project-finance']
  },

  'home-loan': {
    name: 'Home Loan',
    heroTitle: 'Home Loans at India\'s Finest Rates',
    heroSub: 'Purchase, construction, plot+construction or balance transfer — home loans from ₹30 Lakh to ₹150 Crore at 7.25% onwards, including overdraft structures that can save lakhs in interest.',
    amount: '₹30 Lakh – ₹150 Cr',
    timeline: '1–3 weeks',
    rate: '7.25% p.a. onwards',
    metaTitle: 'Home Loan at 7.25% Onwards | LOANYARD CAPITAL',
    metaDescription: 'Home loans ₹30 Lakh–₹150 Cr at 7.25% onwards. Purchase, construction, NRI, balance transfer & overdraft options. 50+ banks compared free.',
    focusKeyword: 'home loan India',
    intro: [
      'A home loan is the largest financial commitment most families ever make — and the most under-negotiated. A 0.5% rate difference on a ₹1 Crore loan is roughly ₹10 Lakh over a 20-year tenure. Choosing the right lender, structure and timing is worth real money.',
      'LOANYARD CAPITAL compares offers across 50+ banks and housing finance companies for every profile: salaried and self-employed, NRIs, professionals, and high-value borrowers whose eligibility benefits from structured income assessment. We negotiate rates, waivers on processing fees and flexible prepayment terms you may never be offered walking into a branch.',
      'Beyond plain-vanilla loans, we advise on home-saver/overdraft structures (park surplus funds to cut interest dramatically), balance transfers with top-ups for renovation or business needs, and construction-linked funding for self-built homes — always matched to your cash-flow reality.'
    ],
    benefits: [
      'Rates from 7.25% p.a., negotiated across 50+ lenders',
      'Loans up to ₹150 Crore for premium properties',
      'Overdraft/home-saver structures that slash interest',
      'Balance transfer + top-up at market-best pricing',
      'NRI home loan programmes with remote documentation',
      'Structured eligibility for self-employed profiles'
    ],
    whoShouldApply: [
      'First-time buyers seeking the sharpest rate',
      'Self-employed borrowers needing smart eligibility assessment',
      'Existing borrowers stuck on high rates (balance transfer)',
      'NRIs buying residential property in India',
      'HNIs financing premium and luxury homes'
    ],
    eligibility: [
      'Age 21–65 at loan maturity',
      'Stable income — salaried or self-employed',
      'Credit score of 700+ for finest pricing',
      'Property with clear title and approvals',
      'LTV up to 90% (slab-linked by loan size)'
    ],
    documents: [
      'KYC and photographs',
      'Salaried: 3-month payslips, Form 16, 6-month bank statements',
      'Self-employed: 2–3 year ITRs & financials, 12-month statements',
      'Property documents: agreement, title chain, approvals',
      'Existing loan details for balance transfer',
      'NRI: passport, visa, NRE/NRO statements, employment proof'
    ],
    industries: ['Salaried Professionals', 'Business Owners', 'Doctors', 'Chartered Accountants', 'NRIs', 'Government Employees', 'IT Professionals', 'Defence Personnel'],
    process: [
      ['Profile & Property Review', 'Eligibility computed across lender policies.'],
      ['Rate Discovery', 'Live comparison and negotiation across 50+ lenders.'],
      ['Application & Login', 'Complete file preparation and submission.'],
      ['Sanction & Legal', 'Valuation and title clearance coordinated.'],
      ['Disbursement', 'Registration-aligned disbursal, fully managed.']
    ],
    faqs: [
      ['What is the lowest home loan rate available?', 'Prime salaried profiles currently access 7.35–8% p.a.; self-employed pricing starts slightly higher and improves with strong financials.'],
      ['How much loan am I eligible for?', 'Typically 60x monthly net income for salaried; self-employed eligibility is computed from financials — our structuring often improves it 20–40%.'],
      ['What is a home-saver / overdraft home loan?', 'A loan linked to an account where parked surpluses reduce interest-bearing principal daily — savings of ₹15–40 Lakh over tenure are realistic for disciplined savers. Try our Home Loan Overdraft Calculator.'],
      ['Should I transfer my existing loan?', 'If your rate exceeds current offers by 0.5%+, transfer usually pays for itself within months. We compute the break-even for you free.'],
      ['Can I get 90% funding?', 'Up to ₹30 Lakh: 90% LTV; ₹30–75 Lakh: 80%; above: 75% — subject to lender policy.'],
      ['Do NRIs get the same rates?', 'NRI pricing is marginally higher at some lenders and identical at others — corridor selection matters; we optimise it.'],
      ['What fees apply?', 'Processing fees of 0–0.5% (frequently waived via our channel), plus statutory charges. No fee is payable to us by you for home loans.'],
      ['How long does approval take?', 'Sanction in 3–7 days for clean salaried files; disbursement follows property legal/valuation, typically 1–3 weeks overall.'],
      ['Can I club my spouse\'s income?', 'Yes — co-applicant income enhances eligibility and can add tax benefits for both borrowers.'],
      ['What tax benefits do home loans carry?', 'Deductions under Section 80C (principal) and 24(b) (interest up to ₹2 Lakh) — consult your CA; we provide the interest certificates.']
    ],
    related: ['loan-against-property', 'business-loans', 'working-capital-finance', 'project-finance']
  }
};
